import { AppDependencies } from "./providers/AppDependenciesProvider";
import { DocumentationAreaController } from "src/contexts/documentationArea/application/DocumentationAreaController";
import { HTTPTranslationRepository } from "src/contexts/translation/infrastructure/HTTPTranslationRepository";
import { TranslationController } from "src/contexts/translation/application/TranslationController";
import { HTTPDocumentationAreaRepository } from "src/contexts/documentationArea/infrastructure/http/HTTPDocumentationAreaRepository";
import { HTTPAuthRepository } from "src/contexts/auth/infrastructure/HTTPAuthRepository";
import { AuthController } from "src/contexts/auth/application/AuthController";

export const appDependencies = (): AppDependencies => {
  const documentationAreaRepository = new HTTPDocumentationAreaRepository();
  const documentationAreaController = new DocumentationAreaController({
    documentationAreaRepository: documentationAreaRepository,
  });

  const translationRepository = new HTTPTranslationRepository();
  const translationController = new TranslationController({
    translationRepository,
  });

  const authRepository = new HTTPAuthRepository();
  const authController = new AuthController({
    authRepository,
  });

  return {
    documentationAreaController,
    translationController,
    authController,
  };
};
